import { Box, FormControl, styled } from '@mui/material';
import { Form } from 'formik';

export const FormStyled = styled(Form, {
  shouldForwardProp: (prop) => prop !== 'isSettingsMainPage',
})(({ theme, isSettingsMainPage }) => ({
  overflowY: 'auto',
  marginTop: isSettingsMainPage && '48px',

  '.formButtonsContainer': {
    backgroundColor: isSettingsMainPage && 'transparent',

    '.submitButton, .backButton': {
      width: '148px',

      [theme.breakpoints.up('md')]: {
        width: '212px',
      },
      [theme.breakpoints.up('lg')]: {
        width: '148px',
      },
    },
  },

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
}));
export const QuestionnaireContainer = styled(Box)(() => ({
  height: '100%',
  overflowY: 'auto',
}));
export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})(({ theme, isHidden }) => ({
  display: isHidden && 'none',
  width: '100%',

  '& .MuiFormControl-root': {
    marginTop: 0,
  },

  '& .MuiFormControlLabel-root': {
    padding: '8px 9px',
    minHeight: '40px',
    height: 'unset',
    backgroundColor: theme.palette.colors.secondaryBackground,

    '&:last-child': {
      marginBottom: 0,
    },

    '& .MuiRadio-root': {
      marginLeft: '9px',

      '& .MuiSvgIcon-root': {
        width: '14px',
        height: '14px',
      },
    },
  },
}));

export const LabelStyled = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isRequired',
})(({ theme, isRequired }) => ({
  fontSize: '14px',
  fontWeight: 500,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  paddingBottom: '16px',

  '&::after': {
    content: "'*'",
    width: '12px',
    height: '12px',
    color: theme.palette.colors.down,
    marginLeft: '4px',
    display: isRequired ? 'inline-block' : 'none',
  },
}));
